import '../../css/base.css';

const Contact = () => {

  return (
    <div className="row">
      <div className="col-12 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <p className="contact-text">If you booked through one of the cottages.com websites and your query concerns booking amendments
                                        then please contact them in the first instance. 
            </p>                                            
            <p className="contact-text">For all other queries our details are below. 
            </p>                                            
            <p className="contact-text"><strong>Mervyn Evans:</strong>
            </p>                                            
            <p className="contact-text">Phone: +447968748839
            </p>                                            
            <p className="contact-text">e-mail: mervyn_evans@hotmail.com
            </p>                        
            <p />                    
            <p className="contact-text"><strong>Lisa Evans:</strong>
            </p>                                            
            <p className="contact-text">Phone: +447968753361
            </p>                                            
            <p className="contact-text">e-mail: lisa_ann_evans@hotmail.com
            </p>                                            
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;